import { render, staticRenderFns } from "./ModalViewDistribution.vue?vue&type=template&id=567addcf&scoped=true"
import script from "./ModalViewDistribution.vue?vue&type=script&lang=js"
export * from "./ModalViewDistribution.vue?vue&type=script&lang=js"
import style0 from "./ModalViewDistribution.vue?vue&type=style&index=0&id=567addcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567addcf",
  null
  
)

export default component.exports